import PropertyFacilitiesContent, { type PropertyFacilityGroup } from 'components/AccommodationKit/PropertyFacilitiesContent'
import PropertyStructuredFacilities from 'components/OfferPage/Property/PropertyStructuredFacilities'

export type AccommodationFacilitiesContent =
  | { kind: 'structured', groups: Array<App.StructuredFacilityGroup> }
  | { kind: 'legacy', markdown: string }
  | { kind: 'grouped', groups: Array<PropertyFacilityGroup> }

export function getPropertyFacilitiesContent(
  property: App.Property.Property,
  structuredFacilities?: Array<App.StructuredFacilityGroup>,
): AccommodationFacilitiesContent | undefined {
  if (structuredFacilities?.length) {
    return { kind: 'structured', groups: structuredFacilities }
  }

  if (property.facilities) {
    return { kind: 'legacy', markdown: property.facilities }
  }

  if (!property.popularFacilities.length && property.amenities.length) {
    return { kind: 'grouped', groups: property.amenities }
  }
}

export function getFlashFacilitiesContent(
  offer: App.Offer,
  structuredFacilities?: Array<App.StructuredFacilityGroup>,
): AccommodationFacilitiesContent | undefined {
  if (structuredFacilities?.length) {
    return { kind: 'structured', groups: structuredFacilities }
  }

  if (offer.facilities) {
    return { kind: 'legacy', markdown: offer.facilities }
  }
}

export function getBedbankFacilitiesContent(
  offer: App.BedbankOffer,
): AccommodationFacilitiesContent | undefined {
  if (offer.property.facilitiesOverride) {
    return { kind: 'legacy', markdown: offer.property.facilitiesOverride }
  }

  if (offer.facilityGroups.length) {
    return {
      kind: 'grouped',
      groups: offer.facilityGroups.map(group => ({
        name: group.name,
        items: group.values,
      })),
    }
  }
}

interface Props {
  content: AccommodationFacilitiesContent
}

function AccommodationFacilities({ content }: Props) {
  if (content.kind === 'structured') {
    return <PropertyStructuredFacilities showHeading={false} structuredFacilities={content.groups} />
  }

  if (content.kind === 'legacy') {
    return <PropertyFacilitiesContent facilities={content.markdown} />
  }

  return <PropertyFacilitiesContent amenities={content.groups} />
}

export default AccommodationFacilities
